// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import VehiclePage from '../../components/Okutaeki/Okutaeki';

interface IProps {
    bondsAllowed: boolean,
    individualAssetsAllowed: boolean
}

const Okutaekjaskra: React.FC<IProps> = ({
    bondsAllowed,
    individualAssetsAllowed
}) => {
    return (
        <Entrypoint>
            <VehiclePage bondsAllowed={bondsAllowed} individualAssetsAllowed={individualAssetsAllowed} />
        </Entrypoint>
    );
}

export default Okutaekjaskra;